<template>
  <div class="documents-list">
    <table class="apoio-datatable">
      <colgroup>
        <col class="column-fileName">
        <col class="column-upload-date">
        <col class="column-actions">
      </colgroup>
      <thead>
        <tr class="apoio-datatable__header-line">
          <th
            title="Nome"
            class="column-fileName"
          >
            NOME DO DOCUMENTO
          </th>
          <th
            title="Data do Upload"
            class="column-upload-date"
          >
            DATA DE UPLOAD
          </th>
          <th
            title="Ações"
            class="column-actions"
          >
            AÇÕES
          </th>
        </tr>
      </thead>
    </table>

    <table
      ref="tableDocuments"
      class="apoio-datatable apoio-datatable-alt apoio-datable-margin-documents"
    >
      <colgroup>
        <col class="column-fileName">
        <col class="column-upload-date">
        <col class="column-actions">
      </colgroup>

      <tbody>
        <tr
          v-for="(document, rowIndex) in documents"
          :key="rowIndex"
        >
          <td
            class="column-fileName"
            :title="document.fileName"
          >
            {{ document.fileName }}
          </td>
          <td
            class="column-upload-date"
            :title="document.updatedAt | date"
          >
            {{ document.updatedAt | date }}
          </td>
          <td class="column-actions">
            <div>
              <div
                class="status-icon icon-download-alt"
                @click="download(document)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Download
                </md-tooltip>
              </div>
              <div
                class="status-icon icon-edit-alt"
                @click="updateDocument(document)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>
              <div
                class="status-icon icon-delete-alt"
                @click="deleteDocument(document.id)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="loading">
        <tr>
          <td colspan="10">
            <infinite-loading
              ref="infiniteLoading"
              :on-infinite="onInfinite"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/common/Spinner'
import Moment from 'moment'

export default {
  name: 'FileList',
  components: {
    'infinite-loading': InfiniteLoading,
    'card-form': CardForm,
    spinner: Spinner
  },
  filters: {
    date: function (value) {
      return Moment(value).format('DD/MM/YYYY')
    }
  },
  props: {
    documents: Array,
    getAllDocuments: Function,
    loading: Boolean
  },
  methods: {
    onInfinite () {
      this.getAllDocuments()
    },
    download (document) {
      this.$emit('download-document', document)
    },
    deleteDocument (fileId) {
      this.$emit('delete-document', fileId)
    },
    updateDocument (document) {
      this.$emit('update-document', document)
    }
  }
}
</script>

<style lang="scss" scoped>
.documents-list {
  width: 100%;

  .apoio-datatable {
    margin: 0px;
  }

  .apoio-datatable-alt {
    margin-bottom: 3em;
  }

  .column {
    &-fileName {
      width: 40%;
      text-overflow: ellipsis !important;
    }
    &-upload-date {
      width: 40%;
    }
    &-actions {
      width: 20%;
    }
  }
}
</style>
